
import axios from '../axios1'
// publishAnalysisChart
export const educationList = (data) => {
  return axios({
    url: '/console/education/list',
    method: 'GET',
    data
  })
}
export const complaintPage = (data) => {
  return axios({
    url: '/console/complaint/page_finish',
    method: 'GET',
    data
  })
}
export const complaintDetail = (data) => {
  return axios({
    url: '/console/complaint/detail',
    method: 'GET',
    data
  })
}
export const schoolList = (data) => {
  return axios({
    url: '/console/school/list_by_grade',
    method: 'GET',
    data
  })
}
export const complaintInsert = (data) => {
  return axios({
    url: '/console/complaint/insert',
    method: 'POST',
    data
  })
}


// WEBPACK FOOTER //
// ./src/http/moudules/complaintPublicity.js